import { qs } from './dom.js';

export function getIrBlasterElements(root = document) {
  const remoteBlasterElement = qs('.ir-blaster', root);
  const mobileBlasterElement = qs('.mobile-ir-blaster', root);
  return [remoteBlasterElement, mobileBlasterElement].filter(Boolean);
}

export function applyIrPowerState(elements, isPowered) {
  elements.forEach(el => {
    if (!isPowered) {
      el.classList.add('power-off');
    } else {
      el.classList.remove('power-off');
    }
    el.classList.remove('is-flashing');
  });
}

export function flashIr(elements, { durationMs = 180 } = {}) {
  if (elements.length === 0) return;

  elements.forEach(el => {
    el.classList.remove('power-off');
    el.classList.remove('is-flashing');
    // Force reflow so the animation restarts on rapid clicks.
    void el.offsetWidth;
    el.classList.add('is-flashing');
  });

  window.setTimeout(() => {
    elements.forEach(el => el.classList.remove('is-flashing'));
  }, durationMs);
}

